// extracted by mini-css-extract-plugin
module.exports = {"title":"HistoryModal_title__nYHIm","content":"HistoryModal_content__lRX8D"};